import React from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { Button } from 'localmed-core';

import { Status } from '../../_universal';
import AlertCircled from '../../legacyCore/icons/AlertCircled';
import WidgetHeader from '../components/WidgetHeader';
import WidgetLayout from '../components/WidgetLayout';
import { intlShape } from '../../shared/shapes';

const NotFoundPage = ({ intl }) => (
  <WidgetLayout
    header={
      <WidgetHeader
        title={intl.formatMessage({
          id: 'widgets.NotFoundPage.pageTitle',
          defaultMessage: 'Oops we can’t find that.',
        })}
        icon={<AlertCircled verticalAlign="center" />}
      />
    }
  >
    <Status statusCode={404} />
    <Helmet>
      <title>
        {intl.formatMessage({
          id: 'widgets.NotFoundPage.pageTitle',
          defaultMessage: 'Page not Found',
        })}
      </title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="padding-md">
      <div className="margin-bottom-md">
        <FormattedHTMLMessage
          id="widgets.NotFoundPage.body"
          // eslint-disable-next-line react/jsx-curly-brace-presence
          defaultMessage={`
          <p>
            You managed to find a 404. Congrats, not even we could do that.
            But since you’re here, would you mind letting us know how you got here?
          </p>
        `}
        />
      </div>
      <p>
        <Button tier="alert" href="/about/our-company/contact/?contactReason=missingPage">
          <FormattedMessage
            id="widgets.NotFoundPage.buttonText"
            defaultMessage="Report our mistake, or just say hey."
          />
        </Button>
      </p>
    </div>
  </WidgetLayout>
);

NotFoundPage.propTypes = {
  // eslint-disable-next-line react/no-typos
  intl: intlShape,
};

export default injectIntl(NotFoundPage);
